import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";
import { mediaUrl } from "@/lib/media";

export default function Journal() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/journal").then((r) => setItems(r.data || [])); }, []);

  return (
    <PublicLayout>
      <Seo
        title="Journal — Stories from the Slower Side of Asia | Abbot Asia"
        description="Notes on the slower side of Asia from Abbot Asia — quieter temples, private dawn ceremonies, and the philosophy behind our journeys."
        path="/journal"
      />
      <section className="pt-40 pb-20 bg-ivory">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12">
          <p className="eyebrow">Journal</p>
          <h1 className="mt-6 font-serif text-5xl md:text-7xl text-jade font-light leading-[1.02] max-w-3xl">
            Notes from the studio.
          </h1>
          <p className="mt-6 text-ink/75 text-[16px] font-light leading-relaxed max-w-xl">
            Occasional writing on the regions we travel, the rituals we attend, and the way we work.
          </p>
        </div>
      </section>

      <section data-testid="journal-list" className="pb-32 bg-ivory">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-12 md:gap-16">
          {items.map((a, i) => (
            <Link key={a.slug} to={`/journal/${a.slug}`} data-testid={`journal-card-${a.slug}`} className={`group fade-up delay-${(i % 3) + 1}`}>
              <div className="aspect-[4/3] overflow-hidden">
                <img src={mediaUrl(a.card_image || a.hero_image)} alt={a.title} className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.04]" />
              </div>
              <p className="eyebrow mt-6">{a.published_at ? new Date(a.published_at).toLocaleDateString("en-GB", { year: "numeric", month: "long" }) : ""}{a.tags?.length ? " · " + a.tags.join(" · ") : ""}</p>
              <h2 className="mt-3 font-serif text-3xl md:text-4xl text-jade font-light leading-tight">{a.title}</h2>
              <p className="mt-4 text-ink/70 text-[15px] font-light leading-relaxed">{a.excerpt}</p>
            </Link>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
